module.exports = __webpack_public_path__ + "static/media/id4-carlos_sa.44a7963e.jpg";